export default {
	PLAIN_TEXT: "text",
	DROPDOWN: "dropdown",
	LINK: "link",
}